"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 -0.2 9 10.3';

var Checkmark = function Checkmark() {
  return _react["default"].createElement("path", {
    d: "M0.881509303,5.93759089 L0.882009303,5.93759089 L0.881509303,5.93759089 Z M3.7320093,10.0375909 C3.7275093,10.0375909 3.7235093,10.0375909 3.7190093,10.0370909 C3.4970093,10.0315909 3.3000093,9.89609089 3.2160093,9.69109089 C2.7470093,8.54559089 1.2790093,6.21109089 0.850509303,5.92609089 C0.579009303,5.81759089 0.435009303,5.51409089 0.528509303,5.23259089 C0.625509303,4.94059089 0.940509303,4.78259089 1.2335093,4.87909089 C1.9115093,5.10409089 3.0455093,6.95609089 3.7230093,8.21309089 C4.9160093,5.78909089 7.0380093,1.79309089 8.1930093,0.22709089 C8.3755093,-0.0214091102 8.7250093,-0.0739091102 8.9725093,0.10909089 C9.2205093,0.29159089 9.2730093,0.64059089 9.0905093,0.88859089 C7.8460093,2.57609089 5.2415093,7.56259089 4.2375093,9.71559089 C4.1455093,9.91209089 3.9485093,10.0375909 3.7320093,10.0375909 Z"
  });
};

var _default = (0, _createSvgIcon["default"])(Checkmark, {
  viewBox: viewBox
});

exports["default"] = _default;